import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * ResultField
 * @param {*} props
 */
export default function ResultField(props) {
  const { label, children } = props;
  return (
    <Box py={1}>
      {label && <Typography variant="overline">{label}</Typography>}
      <Box><Typography variant='h6'>{children}</Typography></Box>
    </Box>
  );
}
